// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3-yZz","col":"styles_col__2foub","fulfillmentStatus":"styles_fulfillmentStatus__2XCmG","emailCol":"styles_emailCol__qAhd5"};